/* unplugin-vue-components disabled */import { render } from "./tenant-af.vue?vue&type=template&id=28b7d86d&scoped=true"
import script from "./tenant-af.vue?vue&type=script&lang=js"
export * from "./tenant-af.vue?vue&type=script&lang=js"

import "./tenant-af.vue?vue&type=style&index=0&id=28b7d86d&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b7d86d"],['__file',"src/pages/tenant/settings/tenant-af.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28b7d86d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28b7d86d', __exports__)) {
    api.reload('28b7d86d', __exports__)
  }
  
  module.hot.accept("./tenant-af.vue?vue&type=template&id=28b7d86d&scoped=true", () => {
    api.rerender('28b7d86d', render)
  })

}


export default __exports__